// extracted by mini-css-extract-plugin
module.exports = {"block":"_5634","list":"_2241","item":"_14655","actions":"_12738","icon":"_11655"};